var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isActive
    ? _c(
        "base-modal-ex",
        {
          attrs: {
            active: _vm.isActive,
            "animation-in": _vm.animationIn,
            "animation-out": _vm.animationOut,
            "animation-duration": _vm.animationDuration,
            "can-cancel": false,
            "min-width": 70,
            "has-modal-card": "",
          },
          on: {
            "update:active": function ($event) {
              _vm.isActive = $event
            },
          },
        },
        [
          _c("header", { staticClass: "modal-card-head" }, [
            _c(
              "p",
              {
                staticClass: "modal-card-title",
                class: { "is-flex-items-center": _vm.showIcon },
              },
              [
                _vm.showIcon
                  ? _c(
                      "span",
                      {
                        staticClass: "icon is-medium",
                        class: `has-text-${_vm.iconType}`,
                        staticStyle: { "margin-right": "0.5rem" },
                      },
                      [
                        _c("i", {
                          staticClass: "mdi mdi-36px",
                          class: `${_vm.iconName}`,
                        }),
                      ]
                    )
                  : _vm._e(),
                _vm._t("text-title"),
              ],
              2
            ),
          ]),
          _c("section", { staticClass: "modal-card-body" }, [
            _c(
              "div",
              [
                _vm.innerValue
                  ? _c("print-options", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.isImageAttachActive,
                          expression: "!isImageAttachActive",
                        },
                      ],
                      attrs: {
                        "sub-quote-nos": _vm.innerValue.isAssessmentEnabled
                          ? _vm.assessments
                          : _vm.innerValue.subQuoteNos,
                      },
                      model: {
                        value: _vm.printOptions,
                        callback: function ($$v) {
                          _vm.printOptions = $$v
                        },
                        expression: "printOptions",
                      },
                    })
                  : _vm._e(),
                _vm.innerValue
                  ? _c("image-select", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isImageAttachActive,
                          expression: "isImageAttachActive",
                        },
                      ],
                      attrs: {
                        "quote-id": _vm.innerValue.quoteId,
                        "quote-ids":
                          _vm.printOptions.quotePrintOptions.selectedQuotes.map(
                            (q) => q.value
                          ),
                        "max-selected": _vm.maxImages,
                        subtitle: `Select ${_vm.maxImages} images to print`,
                      },
                      model: {
                        value: _vm.imagesSelectedForPrint,
                        callback: function ($$v) {
                          _vm.imagesSelectedForPrint = $$v
                        },
                        expression: "imagesSelectedForPrint",
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
          ]),
          _c(
            "footer",
            {
              staticClass: "modal-card-foot",
              style: `justify-content: flex-${_vm.buttonLocation}`,
            },
            [
              _c(
                "button",
                {
                  staticClass: "button is-success tooltip",
                  attrs: {
                    "data-tooltip": "Generate report(s)",
                    disabled: !_vm.canPrint,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.ok()
                    },
                  },
                },
                [
                  _c("span", { staticClass: "icon is-small" }, [
                    _c("i", { staticClass: "mdi mdi-18px mdi-printer" }),
                  ]),
                  _c("span", [_vm._v("Ok")]),
                ]
              ),
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.attachDisabled,
                      expression: "!attachDisabled",
                    },
                  ],
                  staticClass: "button is-primary tooltip",
                  attrs: {
                    "data-tooltip": [
                      !_vm.toggleAttachButton ? "Attach images" : "Done",
                    ],
                    disabled: _vm.attachDisabled,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.attach()
                    },
                  },
                },
                [
                  !_vm.toggleAttachButton
                    ? _c("span", { staticClass: "icon is-small" }, [
                        _c("i", { staticClass: "mdi mdi-18px mdi-paperclip" }),
                      ])
                    : _c("span", [_vm._v("Done")]),
                ]
              ),
              _c(
                "button",
                {
                  staticClass: "button tooltip",
                  attrs: {
                    "data-tooltip": "Cancel",
                    disabled: _vm.cancelDisabled,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.cancel()
                    },
                  },
                },
                [_vm._v("Cancel")]
              ),
            ]
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }